const hoursTypeMap = {
  FULL_TIME: "Full time",
  PART_TIME: "Part time",
  BOTH: "Full time / Part time",
};

const contractTypeMap = {
  PERMANENT: "Permanent",
  TEMPORARY: "Temporary",
};

export { hoursTypeMap, contractTypeMap };
